import { Icon } from "../Icon/Icon";
import "../utils.scss";
import "./DropdownMenuItem.scss";
interface DropdownMenuItemProps {
  label: string;
  maxLabelLength?: number;
  iconName?: string;
  svgIcon?: React.ReactNode;
  isDestructive?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  testId?: string;
}

const truncateLabel = (label: string, max?: number) => {
  if (!max || max <= 0 || label.length <= max) {
    return label;
  }

  if (max <= 1) {
    return "…";
  }

  return `${label.slice(0, max - 1)}…`;
};

export const DropdownMenuItem: React.FC<DropdownMenuItemProps> = ({
  iconName,
  svgIcon,
  isDestructive,
  label,
  maxLabelLength,
  onClick,
  disabled,
  testId,
}) => {
  const destructiveClass = isDestructive ? "dropdown-menu-item--destructive" : "";
  const disabledClass = disabled ? "dropdown-menu-item--disabled" : "";
  const displayLabel = truncateLabel(label, maxLabelLength);

  return (
    <li className={`dropdown-menu-item ${destructiveClass} ${disabledClass}`} data-testid={testId}>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
      <span
        className="dropdown-menu-item__button"
        data-testid={testId ? `${testId}-button` : undefined}
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled) {
            onClick?.();
          }
        }}
      >
        {iconName || svgIcon ? (
          <Icon svgIcon={svgIcon} iconName={iconName} className="dropdown-menu-item__icon" />
        ) : null}
        <span className="dropdown-menu-item__label no-select">{displayLabel}</span>
      </span>
    </li>
  );
};
